module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("enaXY"))).then(() => parcelRequire('hEqeo'));